const EXAMPLE_VIN = 'W1K2971552A00000';

const TITLES = [
	...Array.from({ length: 36 }, (_, i) => `EXT${String(i * 10).padStart(3, '0')}`),
	...Array.from({ length: 4 }, (_, i) => `INT${i + 1}`),
	...Array.from({ length: 6 }, (_, i) => `BIS${i + 1}`),
];

export const exampleVin = EXAMPLE_VIN;

/**
 * Lazily loads the bundled sample vehicle so the demo does not need an API key.
 */
export const loadExampleImages = async () => {
	const images = await Promise.all(
		TITLES.map(async (title) => {
			const module = await import(`../../../Assets/Vimdt/ExampleImages/${title}.json`);
			return { title, url: module.b64 ?? module.default?.b64, imageId: title };
		})
	);

	return { [EXAMPLE_VIN]: images };
};

export default loadExampleImages;
